import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { PositivePayCheckTemplate, PositivePayCheckFile } from "model";

/**
* @class PositivePayImportedChecksUsingTemplateHistory
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _id - The id of the history.
* @property {STRING} _account - The account of the check.
* @property {PositivePayCheckTemplate} _template - The template of the history.
* @property {PositivePayCheckFile} _file - The file of the history.
* @property {STRING} _confirmationNumber - The confirmation number of the history.
* @property {ARRAY} _checks - The ids of the checks of the history.
* @extends BCMSRecord
* @example const record = model.positivePayImportedChecksUsingTemplateHistory[0];
* const history = new PositivePayImportedChecksUsingTemplateHistory(record);
*/
export default class PositivePayImportedChecksUsingTemplateHistory extends BCMSRecord {
    _id
    _template
    _file
    _confirmationNumber
    _checks

    constructor(record) {     
      super(record) 
    }
  }
  
  PositivePayImportedChecksUsingTemplateHistory.define({
    "recordType": "positivePayImportedChecksUsingTemplateHistory",
    "recordIDProp":"id",
    "className" : "PositivePayImportedChecksUsingTemplateHistory",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {STRING} - gets the id 
         * @property set {STRING} - sets the id 
         * @memberof PositivePayImportedChecksUsingTemplateHistory
         */
        BCMSRecordProperty.mapToString("id","_id"),

        /** 
         * @name template
         * @instance
         * @property get {PositivePayCheckTemplate} - gets the template 
         * @property set {PositivePayCheckTemplate} - sets the template 
         * @memberof PositivePayImportedChecksUsingTemplateHistory
         */
        BCMSRecordProperty.mapToClass("template","_template", () => PositivePayCheckTemplate),

        /** 
         * @name file
         * @instance
         * @property get {PositivePayCheckFile} - gets the file 
         * @property set {PositivePayCheckFile} - sets the file 
         * @memberof PositivePayImportedChecksUsingTemplateHistory
         */
        BCMSRecordProperty.mapToClass("file","_file", () => PositivePayCheckFile),

        /** 
         * @name confirmationNumber
         * @instance
         * @property get {STRING} - gets the confirmation number 
         * @property set {STRING} - sets the confirmation number 
         * @memberof PositivePayImportedChecksUsingTemplateHistory
         */
        BCMSRecordProperty.mapToString("confirmationNumber","_confirmationNumber"),

        /**
         * @name checks
         * @instance
         * @property get {ARRAY} - gets the _checks
         * @property set {ARRAY} - sets the _checks
         * @note The mapToArray currently does not work correctly when the toRecord function is called
         * @memberof PositivePayImportedChecksUsingTemplateHistory
         */
        BCMSRecordProperty.mapTo({
            id: "checks",
            instanceField: "_checks",
            setter: function(value) {
              if(value === undefined || Array.isArray(value)) {
                this._checks = value;
              } else {
                this._checks = value === "" ? [] : value.split(",");
              }
            },
            toRecord: function() {
                return this._checks === undefined || this._checks.length === 0
                    ? ""
                    : this._checks.reduce((result, item) => `${ result },${ item }`);
            }
        }),
        ]  
})




